import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";

export default function Login() {
  const { login, loading, error, clearError } = useAuth();
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  const [formError, setFormError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setFormError("");
    clearError && clearError();
  };

  // ✅ CORRECTION : handleLogin doit être une fonction
  const handleLogin = async (e) => {
    e.preventDefault();
    setFormError("");

    // Validation basique
    if (!formData.email || !formData.password) {
      setFormError("Veuillez remplir tous les champs");
      return;
    }

    console.log('🔄 Début de la connexion...');
    
    // ✅ Vérification que login est bien une fonction
    if (typeof login === 'function') {
      try {
        const result = await login(formData.email, formData.password);
        
        if (result && result.success) {
          console.log('✅ Connexion réussie, redirection...');
          navigate("/");
        } else {
          setFormError(result?.error || 'Erreur de connexion');
        }
      } catch (error) {
        console.error('❌ Erreur lors de la connexion:', error);
        setFormError('Une erreur est survenue lors de la connexion');
      }
    } else {
      console.error('❌ login n\'est pas une fonction:', login);
      setFormError('Erreur système - veuillez recharger la page');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#fffaf3] py-12 px-4">
      <div className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-md border border-[#e8e2d1]">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-serif font-light text-[#2f2a1e] mb-2">
            Connexion
          </h2>
          <p className="text-[#7a7250] text-sm">
            Accédez à votre compte
          </p>
        </div>

        {(error || formError) && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
            {error || formError}
          </div>
        )}
        
        {/* ✅ CORRECTION : onSubmit={handleLogin} */}
        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-[#2f2a1e] text-sm font-light mb-2">
              Email
            </label>
            <input 
              type="email" 
              name="email"
              placeholder="Votre email" 
              value={formData.email} 
              onChange={handleChange}
              className="w-full p-3 border border-[#e8e2d1] rounded-lg focus:outline-none focus:border-[#d0b125] transition placeholder-[#7a7250]"
              required
              disabled={loading}
            />
          </div>
          
          <div>
            <label className="block text-[#2f2a1e] text-sm font-light mb-2">
              Mot de passe
            </label>
            <input 
              type="password" 
              name="password"
              placeholder="Votre mot de passe" 
              value={formData.password} 
              onChange={handleChange}
              className="w-full p-3 border border-[#e8e2d1] rounded-lg focus:outline-none focus:border-[#d0b125] transition placeholder-[#7a7250]"
              required
              disabled={loading}
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className="w-full bg-[#2f2a1e] text-white py-4 rounded-lg hover:bg-[#d0b125] transition duration-300 font-light text-lg disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <span className="flex items-center justify-center">
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Connexion...
              </span>
            ) : (
              "Se connecter"
            )}
          </button>
        </form>

        <div className="mt-8 text-center">
          <p className="text-[#7a7250] text-sm">
            Pas encore de compte ?{" "}
            <Link 
              to="/register" 
              className="text-[#d0b125] hover:underline font-light transition"
            >
              Créer un compte
            </Link>
          </p>
        </div>

      
      </div>
    </div>
  );
}